import React from 'react';
import Select from 'react-select';
import { selectStyles, SelectLayout } from './selectStyles';
import PropTypes from 'prop-types';
import Label from '../Label';
import HelperText from '../HelperText';

const ReactSelect = ({
  name,
  label,
  ariaLabel,
  errorMessage,
  helperText,
  isDisabled,
  ...props
}) => (
  <SelectLayout>
    <Label errorMessage={errorMessage} htmlFor={name}>
      {errorMessage || label}
    </Label>
    {helperText && <HelperText>{helperText}</HelperText>}
    <Select
      aria-label={ariaLabel}
      id={name}
      name={name}
      isDisabled={isDisabled}
      styles={selectStyles(errorMessage)}
      {...props}
    />
  </SelectLayout>
);

ReactSelect.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  errorMessage: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool,
  helperText: PropTypes.string,
};

ReactSelect.defaultProps = {
  errorMessage: undefined,
  helperText: undefined,
  iconDecoration: undefined,
  isClearable: false,
  isDisabled: false,
  isMulti: false,
  isSearchable: false,
  placeholder: 'Select',
};

export default ReactSelect;
